module.exports = __webpack_public_path__ + "static/media/chevron-down.cf078fb2.svg";